import { useTranslation } from 'react-i18next'

import { wwtMemo } from '@wwt/custom/wwt'

import { cn } from '@/shared/lib/cn'

import { Button, type ButtonProps } from '../Button.tsx'
import { DislikeIcon } from './DislikeIcon.tsx'

interface DislikeIconButtonProps extends Omit<ButtonProps, 'onClick'> {
	onClick: () => void
	isDisliked: boolean
	className?: string
}

/**
 * Show icon button with dislike
 *
 * @author Ivan Shchedrovskyi
 */
export const DislikeIconButton = wwtMemo(
	({ isDisliked, onClick, className, ...props }: DislikeIconButtonProps) => {
		const { t } = useTranslation('home-page')

		return (
			<Button
				className={cn('group z-0 h-12 w-10', className)}
				variant="flat"
				size="icon-sm"
				aria-label="dislike-room"
				onClick={onClick}
				data-active={isDisliked}
				title={t('dislike', { ns: 'tooltips' })}
				{...props}
			>
				<DislikeIcon />
			</Button>
		)
	}
)
